<template>
  <div class="flights-content">
    <!-- Buscador en el HERO con fondo (teleport) -->
    <template v-if="hasHeroSlot">
      <teleport to="#hero-slot">
        <!-- Cuadrícula de servicios solo para móvil -->
        <ServiceGridComp class="flights-service-grid" />
        <FlightSearch @search="flightsSearch" class="flight-search-form" />
      </teleport>
    </template>
    <template v-else>
      <!-- Fallback si no existe el hero-slot -->
      <div class="search-fallback">
        <FlightSearch @search="flightsSearch" />
      </div>
    </template>

    <!-- BANNER: sin fondo -->
    <section class="banner">
      <div class="banner__content">
        <FlightBannerComp />
        <!-- Reemplaza este bloque por tu banner real o componente -->
      </div>
    </section>

    <!-- BANNER SERVICIOS COMPLEMENTARIOS -->
    <ServicesBannerComp />

    <!-- RESULTADOS: sin fondo -->
    <!--<section class="results"></section>-->
  </div>
</template>

<script>
import FlightSearch from "@/components/FlightSearchComp.vue";
import ServiceGridComp from "@/components/ServiceGridComp.vue";
import FlightBannerComp from "@/components/FlightBannerComp.vue";
import ServicesBannerComp from "@/components/ServicesBannerComp.vue";
import { setFlightResults, clearFlightResults } from "@/stores/flightstore.js";
import travelApi from "@/services/httpaxios.js";
import { startLoading, stopLoading } from "@/stores/loadingstore.js";

export default {
  name: "FlightsView",
  components: {
    FlightSearch,
    FlightBannerComp,
    ServiceGridComp,
    ServicesBannerComp,
  },
  data() {
    return {
      flights: [],
      hasHeroSlot: false, // Detecta si App.vue expuso el #hero-slot
    };
  },
  mounted() {
    // Limpiamos los resultados de vuelos anteriores al entrar a esta vista.
    clearFlightResults();
    // Es importante verificar si el slot existe para renderizar correctamente.
    // Usamos nextTick para asegurarnos de que el DOM de App.vue esté listo.
    this.$nextTick(() => {
      this.hasHeroSlot = !!document.getElementById("hero-slot");
    });
  },
  methods: {
    async flightsSearch(payload) {
      startLoading(); // <-- INICIAMOS LA CARGA
      try {
        const response = await travelApi.post("Flights/search", payload);

        // --- PUNTO CLAVE PARA DEPURACIÓN ---
        // Imprimimos la respuesta como un string JSON formateado.
        // Esto facilita copiar y analizar la estructura de los datos.
        /*console.log(
          "Respuesta de la API (JSON):",
          JSON.stringify(response.data, null, 2),
        );*/

        if (!response.data || response.data.length === 0) {
          console.error("No se encontraron vuelos");
          // Aquí podrías mostrar una notificación de "No hay resultados"
          return;
        }
        // Guarda los resultados en el store
        setFlightResults(response.data, payload);
        // Redirige a la nueva página de resultados
        this.$router.push({ name: "FlightResults" });
      } catch (error) {
        console.error("Error en la búsqueda:", error);
        alert("Lo sentimos, no encontramos vuelos para los criterios seleccionados. Por favor, inténtalo de nuevo.");
        stopLoading(); // <-- DETENEMOS LA CARGA SI HAY UN ERROR
      } finally {
        // No detenemos el loading aquí, porque la navegación a la siguiente página lo hará.
      }
    },
  },
};
</script>

<style scoped>
.flights-content {
  display: block;
}

/* Fallback del buscador si no hay hero-slot */
.search-fallback {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
}

/* --- BANNER (sin fondo de imagen) --- */
.banner {
  background: #fff; /* asegura fondo neutro */
  border-bottom: 1px solid #eef2f7;
}
.banner__content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 5% 5%;
}

/* --- RESULTADOS (sin fondo) --- */
.results {
  max-width: 1200px;
  margin: 16px auto;
  padding: 0 16px;
}

.flights-service-grid {
  display: none; /* Oculto en escritorio por defecto */
}

/* --- Responsive Design --- */
@media (max-width: 1024px) {
  .flights-service-grid {
    display: grid; /* Mostramos la cuadrícula en móvil */
  }

  .flight-search-form {
    margin-top: 20px; /* Añadimos espacio entre la cuadrícula y el buscador */
  }
}
</style>
